// extracted by mini-css-extract-plugin
export default {"text":"style_text__bu+9L","confirmation":"style_confirmation__cj0qk","confirmation__text":"style_confirmation__text__dG4R0","confirmation__link":"style_confirmation__link__uXxqC"};